import { axiosBase } from "./axiosbase"

const getNFTBenefits = (tokenId) => {
  return axiosBase.get(`/benefits/token/${tokenId}?limit=0`)
}

export { getNFTBenefits }
